export const VERSION_INFO = { tag: '2.82.0', branch: '2.82.0', commit: 'd580242c8d660bc0326bb2d44f50d0a4215aac48', date: 'Mon Dec  1 16:20:28 UTC 2025' }
